import React from "react";
import Layout from "../Layout";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TaskWork from "../../../shared/Layout/TaskWork";
import NowWorks from "../../../widgets/management/dashboard/NowWorks";
import NowWeekend from "../../../widgets/management/dashboard/NowWeekend";
// import RatingOperators from "../../../shared/Layout/RatingTable";
import GreenFireComponent from "../../../widgets/management/dashboard/GreenFireComponent";
import { currentDays } from "../../../data/management/greenFireComponent";
import { prizes } from "../../../data/management/greenFireComponent";
import { operatorsRatingManagement } from "../../../data/management/operatorsRating";
import RatingTableContainer from "../../../shared/OperatorsList/RatingTable";

function Dashboard(props) {
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            xl: "row",
          },
          gap: 2,
          alignItems: "stretch",
          mb: 2,
        }}
      >
        <Box
          sx={{
            flex: { xl: "0 0 70%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TaskWork title="Завдання для операторів" activeCount={5} />
        </Box>

        <Box
          sx={{
            flex: { xl: "0 0 29%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <GreenFireComponent currentDays={currentDays} prizes={prizes} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            xl: "row",
          },
          gap: 2,
          alignItems: "stretch",
          mb: 2,
        }}
      >
        <Box
          sx={{
            flex: { xl: "0 0 70%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <NowWorks />
        </Box>

        <Box
          sx={{
            flex: { xl: "0 0 29%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <NowWeekend />
        </Box>
      </Box>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <RatingTableContainer
          operatorsRating={operatorsRatingManagement}
          title="Рейтинг операторів (Management)"
        />
      </Grid>
    </Layout>
  );
}

export default Dashboard;
